import { render, staticRenderFns } from "./AbonosComponent.vue?vue&type=template&id=40bef804&"
import script from "./AbonosComponent.vue?vue&type=script&lang=js&"
export * from "./AbonosComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports